<template>
  <div class="container content-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>应用管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/agreement/list' }">协议管理</el-breadcrumb-item>
        <el-breadcrumb-item>协议添加</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
        </div>
        <div class="right">
          <el-button plain @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">协议编辑</h3>
      <div class="content">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="130px" class="dataForm">
          <el-form-item label="协议名称" prop="name">
            <el-input v-model="dataForm.name" placeholder="输入协议名称"></el-input>
          </el-form-item>
          <el-form-item label="协议编码：" prop="code">
            <el-input v-model="dataForm.code" placeholder="输入协议编码"></el-input>
          </el-form-item>
          <el-form-item class="agreement-detail" label="协议内容：" prop="content">
            <VueEditor
              class="v-editor"
              :content="dataForm.content"
              placeholder="请输入协议内容"
              @change="handleContentChange"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import VueEditor from '@/components/VueEditor'
import { agreementCreate } from '@/api/operation'

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      dataForm: {
        name: '',
        code: '',
        content: '',
      },
      rules: {
        name: [{ required: true, message: '请输入协议名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入协议编码', trigger: 'blur' }],
        content: [{ required: true, message: '请输入协议内容', trigger: 'blur' }],
      }
    }
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    handleContentChange(editor) {
      this.dataForm.content = editor.html
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm)
          agreementCreate(params).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()

            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
.content-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .main .content {
    display: flex;
    margin-top: 20px;

    .v-editor {

      /deep/ .ql-container {
        min-height: 500px !important;
      }
    }
  }
}
</style>
